/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Global functions
  function get_window_width(){
    var overflow_x = $('body').css('overflow-x');
    var overflow_y = $('body').css('overflow-y');

    $('body').css('overflow', 'hidden');

    var window_width = $(window).width();

    $('body').css({ 'overflowX': overflow_x, 'overflowY': overflow_y });

    return window_width;
  }

  var window_height = $(window).height();
  var window_width = get_window_width();

  function definite_resize(){
    var definite_resize = false;

    if( current_window_size !== $(window).width() ){
      definite_resize = true;
    }

    current_window_size = $(window).width();

    return definite_resize;
  }


  // Theme specific functions
  var FOUR_REAL = {
    fade_in_initial_hidden: function() {
      $('.initial_hidden:not(.hidden_home)').each(function(i) {
        var delay = (i + 1) * 250;
        var element = $(this);

        setTimeout(function(){
          element.css('opacity', '1');
        }, delay);


      });
    },
    calculate_toggle_position: function() {
      var menu_toggle = $('#menu_toggle');

      if( menu_toggle.length && window_width >= 768 ){

        var toggle_offset = menu_toggle.offset().left;
        var menu_inr = $('#menu_overlay > .inr');
        var banner_text = $('.banner_image .banner_text .inr');

        menu_inr.css('padding-left', toggle_offset + 'px');
        banner_text.css('padding-left', toggle_offset + 'px');
      }
    },
    calculate_gallery_position: function() {
      var container_offset = $( '.case_studies .case_study.odd .inr .image ' ).offset().left;
      var gallery = $( '.gallery_carousel #home_gallery > .owl-stage-outer' );

      if( container_offset && gallery && window_width >= 768 ){
        gallery.css('margin-left', container_offset + 'px');
      }
    },
    // ajax_mailchimp: function() {

    //   $("#mc-embedded-subscribe-form").submit(function(e) {
 
    //     var url = $(this).prop('action'); // the script where you handle the form input.

    //     $.ajax({
    //            type: 'GET',
    //            url: url,
    //            data: $('#mc-embedded-subscribe-form').serialize(), // serializes the form's elements.
    //            dataType: 'jsonp',
    //            success: function(data) {
    //             if( data.result == 'success' ){
    //               window.location.href = 'https://example.franciskim.co/thank-you.html';
    //             }
    //            }
    //          });
     
    //     e.preventDefault(); // avoid to execute the actual submit of the form.
    // });
      
    // },
    // ajax_register_mailchimp: function( $form ) {
    //   var $form = $('#mc-embedded-subscribe-form');
    //   $('#mc-embedded-subscribe').val('Sending...');

    //   console.log( $form.attr('method') );
    //   console.log( $form.attr('action') );
    //   console.log( $form );

    //   $.ajax({
    //     type: $form.attr('method'),
    //     url: $form.attr('action'),
    //     data: $form.serialize(),
    //     cache: false,
    //     dataType: 'json',
    //     contentType: 'application/json; charset=utf-8',
    //     error: function( err ) {
    //       alert('Could not connect to the registration server. Please try again later.')
    //     },
    //     success: function( data ) {
    //       $('#mc-embedded-subscribe').val('subscribe');

    //       if( data.result === 'success' ) {
    //         // Yeahhhh Success
    //         console.log(data.msg);

    //         $('#mce-success-response').html('<p>Thank you for subscribing.</p>');
    //         $('#mce-EMAIL').val('');
    //       } else {
    //         // Something went wrong, do something to notify the user.
    //         console.log(data.msg);

    //         $('#mce-error-response').html('<p>' + data.msg.substring(4) + '</p>');
    //       }
    //     }
    //   });
    // },
    // ajax_mailchimp: function() {
    //   var $form = $('#mc-embedded-subscribe-form');

    //   if( $form.length > 0 ) {
    //     $('form input[type="submit"]').bind('click', function( event ) {
    //       if( event ){
    //         event.preventDefault();

    //         FOUR_REAL.ajax_register_mailchimp( $form );
    //       }
    //     });
    //   }
    // },
    preloader: function() {
      var preload = $('#preload');
      var preload_data = {
        container: preload[0],
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: preload.data('anim')
      };
      var preload_anim = bodymovin.loadAnimation(preload_data);

      // if( Cookies.get('preload_complete') !== 'true' ){
        preload_anim.play();

        preload_anim.addEventListener('complete', function(){
          preload.addClass('finished'); // fade-out

          setTimeout(function(){
            preload.css('display', 'none'); // hide
          }, 450);

          $('body').addClass('loaded'); // fade-out

          // Slide in home banner after preloader finished
          setTimeout(function(){
            $( '.banner.home .banner_text' ).addClass( 'open' );
          }, 250);

          $('.initial_hidden.hidden_home').each(function(i) {
            var delay = (i + 1) * 250;

            $(this).delay(delay).css('opacity', '1');
          });

          // Cookies.set('preload_complete', 'true');
        });

      // } else {
        // preload.css('display', 'none');
      // }

    },
    // render_slider_init: function() {
    //   // var render_container = $('.b-dics');
    //   var render_container = document.querySelector('.b-dics');

    //   if( render_container.length ) {
    //     new Dics({
    //       container: render_container,
    //       hideTexts: true,
    //     });
    //   }
    // },

  };


  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        FOUR_REAL.preloader();
        FOUR_REAL.calculate_toggle_position();
        // FOUR_REAL.calculate_gallery_position();

        $(window).load(function() {
          FOUR_REAL.fade_in_initial_hidden();
          // FOUR_REAL.ajax_mailchimp();
          // document.addEventListener( 'DOMContentLoaded', FOUR_REAL.render_slider_init() );
        });

        // Menu toggle
        $('#menu_toggle').click(function(){
          $(this).toggleClass('open');
          $('body').toggleClass('menu_open');
          $('#menu_overlay').toggleClass('open');
        });

        // Close menu if clicked outside
        $(document).mouseup(function(e){
          var menu = $('#menu_overlay, #menu_toggle');

          if( !menu.is(e.target) && menu.has(e.target).length !== 1 ){
            $('#menu_toggle').removeClass('open');
            $('body').removeClass('menu_open');
            $('#menu_overlay').removeClass('open');
          }
        });

      // Animated logo
        var anim_logo_container = $('#anim_logo');
        var anim_logo_data = {
          container: anim_logo_container[0], // the dom element that will contain the animation
          renderer: 'svg',
          loop: false,
          autoplay: false,
          path: anim_logo_container.data('anim')
        };
        var anim_logo = bodymovin.loadAnimation(anim_logo_data); // Load animation

        anim_logo_container.hover(
          function() {
            // anim_logo.addClass('open');
            anim_logo.playSegments( [0,50], true );
          }, function() {
            // anim_logo.removeClass('open');
            anim_logo.playSegments( [50,0], true );
          }
        );


      // Chevron arrows
      var anim_chevron_container = $('#chevrons');
      var anim_chevron_data = {
        container: anim_chevron_container[0], // the dom element that will contain the animation
        renderer: 'svg',
        loop: true,
        autoplay: false,
        path: anim_chevron_container.data('anim')
      };
      var anim_chevron = bodymovin.loadAnimation(anim_chevron_data); // Load animation
      anim_chevron.play();


      // Home gallery carousel
      $('#home_gallery').on('initialized.owl.carousel', function(event) {
        FOUR_REAL.calculate_gallery_position();
      }).owlCarousel({
        margin:30,
        dots:true,
        dotsEach:1,
        nav:false,
        loop:false,
        responsiveClass:true,
        responsive:{
          991:{
            items:2
          },
          0:{
            items:1
          }
        }
      });

      // Home page gallery - LightGallery
      $('#home_gallery').lightGallery({
        selector: '.item'
      });

      // Custom nav for home gallery carousel
      $('#home_nav .nav.next').click(function(){
        $('#home_gallery').trigger('next.owl.carousel');
      });
      $('#home_nav .nav.prev').click(function(){
        $('#home_gallery').trigger('prev.owl.carousel');
      });


      // Case study gallery carousel
      $('.case_study_gallery').on('initialized.owl.carousel', function(event) {
        var container_offset = $('.testimonial .inr').offset().left;
        var gallery = $('.gallery_carousel .owl-carousel > .owl-stage-outer');
        gallery.css('margin-left', container_offset + 'px');
      }).owlCarousel({
        margin:30,
        dots:true,
        dotsEach:1,
        nav:false,
        loop:false,
        mouseDrag:false,
        responsiveClass:true,
        responsive:{
          991:{
            items:2
          },
          0:{
            items:1
          }
        }
      });

      // Case study detail page gallery - LightGallery
      $('.case_study_gallery').lightGallery({
        selector: '.item'
      });

      // Custom nav for case study gallery carousel
      $('#case_study_nav .nav.next').click(function(){
        $('.case_study_gallery').trigger('next.owl.carousel');
      });
      $('#case_study_nav .nav.prev').click(function(){
        $('.case_study_gallery').trigger('prev.owl.carousel');
      });


      // Testimonial carousel
      $('#testimonials').owlCarousel({
        margin:0,
        dots:true,
        dotsEach:1,
        nav:false,
        loop:false,
        responsiveClass:true,
        responsive:{
          0:{
            items:1
          }
        }
      });

      // Custom nav for testimonial carousel
      $('#testimonial_nav .nav.next').click(function(){
        $('#testimonials').trigger('next.owl.carousel');
      });
      $('#testimonial_nav .nav.prev').click(function(){
        $('#testimonials').trigger('prev.owl.carousel');
      });


      // Gallery Page - LightGallery
      $('#gallery').lightGallery({
        selector: '.gallery_item'
      });

      // Studio page video
      // -- remove overlay and play video
      $('#studio_play').click(function(){
        $('#studio_video').get(0).play();
        $('.video_poster').addClass('fade_out');
        $(this).addClass('fade_out');
      });

      //Studio page video
      // -- add overlay back at end of video
      $('#studio_video').on('ended', function(){
        $('.video_poster').removeClass('fade_out');
        $('#studio_play').removeClass('fade_out');
      });

      
      // VR page video
      // -- remove overlay and play video
      $('#vr_play').click(function(){
        $('#vr_video').get(0).play();
        $('#vr_poster').addClass('fade_out');
        $(this).addClass('fade_out');
      });

      // VR page video
      // -- add overlay back at end of video
      $('#studio_video').on('ended', function(){
        $('#vr_poster').removeClass('fade_out');
        $('#studio_play').removeClass('fade_out');
      });



      $(document).ready(function() {
        var item = $('#gallery .gallery_item');
        var items = item.length;
        var item_increase = 10;

        // console.log( item );
        // console.log( 'initial_length: ' + items );
        // console.log( shown );

        item.slice(0,10).show();

        $('#gallery_load_more').click(function () {
          item_length = item.length;
          current_length = $('.gallery_item:visible').length;
          next_length = $('.gallery_item:visible').length + item_increase;

          // console.log( 'item_length: ' + item_length );
          // console.log( 'current_length: ' + current_length );
          // console.log( 'next_length: ' + next_length );

          if( item_increase < items ) {
            // item.slice(0, 6).show();

            item.slice(current_length, next_length).each(function(i) {
              $(this).delay(500).show(250);
            });

            if( next_length > item_length ){
              $('#gallery_load_more').hide();
            }

            // $('.gallery_item:lt(' + item_increase + ')').show(300);
          } else {

            // if( next_length > item_length ){
            //   $('#gallery_load_more').hide();
            // }
            // $('.gallery_item:lt(' + items + ')').show(300);
            // item.slice(current_length, next_length).show(500);

            // $('#gallery_load_more').hide();
          }
        });

      });

    

      // Slider
        // $('#gallery').owlCarousel({
        //   loop:true,
        //   // margin:50,
        //   responsiveClass:true,
        //   responsive:{
        //     991:{
        //       items:2,
        //       nav:true,
        //       navRewind: false
        //     },
        //     0:{
        //       items:1,
        //       nav:true,
        //       navRewind: false
        //     }
        //   }
        // });

        // $('#testimonial').owlCarousel({
        //   margin:10,
        //   responsiveClass:true,
        //   responsive:{
        //     1100:{
        //       items:3,
        //       nav:true,
        //       loop:true,
        //       navRewind: false
        //     },

        //     991:{
        //       items:1,
        //       nav:true,
        //       loop:true,
        //       navRewind: false
        //     },
        //     0: {
        //       items:1,
        //       nav:true,
        //       loop:true,
        //       navRewind: false
        //     }
        //   }
        // });

        // $('.testimonial').owlCarousel({
        //   margin:10,
        //   responsiveClass:true,
        //   responsive:{
        //     0: {
        //       items:1,
        //       nav:true,
        //       loop:true,
        //       navRewind: false
        //     }
        //   }
        // });

      //Remove disable class if nav:true does not work 
        // $('.owl-carousel').find('.owl-nav').removeClass('disabled');
        // $('.owl-carousel').on('changed.owl.carousel', function(event) {
        //   $(this).find('.owl-nav').removeClass('disabled');
        // });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.


// Render slider init - https://github.com/abelcabezaroman/definitive-image-comparison-slider
function render_sliders_init() {
  // var render_container = document.querySelectorAll('.b-dics')[0];

  if( document.querySelector('.b-dics') ) {
    new Dics({
      container: document.querySelector('.b-dics'),
      hideTexts: true,
    });
  }

  if( document.querySelector('.b-dics-2') ) {
    new Dics({
      container: document.querySelector('.b-dics-2'),
      hideTexts: true,
    });
  }

  if( document.querySelector('.b-dics-3') ) {
    new Dics({
      container: document.querySelector('.b-dics-3'),
      hideTexts: true,
    });
  }

}
document.addEventListener( 'DOMContentLoaded', render_sliders_init );